import React from 'react'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'

import styles from './../../Dialog.module.sass'
import toBool from 'utils/toBool'
import EditPresetForm from './EditPresetForm'

export const APPOINTMENT_PROTOCOLS = toBool(
	window.REACT_APP_APPOINTMENT_PROTOCOLS ||
		process.env.REACT_APP_APPOINTMENT_PROTOCOLS
)
export const MEDICAL_ACT_PROTOCOLS = toBool(
	window.REACT_APP_MEDICAL_ACT_PROTOCOLS ||
		process.env.REACT_APP_MEDICAL_ACT_PROTOCOLS
)

const EditPresetProtocolDialog = (props) => {
	const { data, dismiss, resolve } = props

	return (
		<VStack className={styles['protocols-root']}>
			<EditPresetForm dismiss={dismiss} resolve={resolve} data={data} />
		</VStack>
	)
}

export default EditPresetProtocolDialog
